import { render, staticRenderFns } from "./PaginatorList.vue?vue&type=template&id=75aaab96"
import script from "./PaginatorList.vue?vue&type=script&lang=js"
export * from "./PaginatorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports